import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {from, of} from 'rxjs';
import {Platform} from '@ionic/angular';
import {catchError, map} from 'rxjs/operators';
import {Plugins} from '@capacitor/core';

const {Device} = Plugins;

@Injectable({
  providedIn: 'root'
})
export class AplicativoService {
  BUNDLE_SUPER_APP = environment.bundleId;

  constructor(private httpClient: HttpClient,
              private platform: Platform
  ) {
  }

  getByBundleId(bundleId: string) {
    return this.httpClient.get<any>(environment.integradorApiUrl + '/' + environment.integradorApiVersion + '/aplicativo/bundle/'
      + bundleId);
  }

  getBundle() {
    if (this.platform.is('hybrid')) {
      return from(Device.getInfo()).pipe(
        map((x: any) => {
          console.log('APP_ID', x.appId);
          console.log('APP', x);
          return x.appId;
        }),
        catchError(() => {
          return of(this.BUNDLE_SUPER_APP);
        })
      );
    }
    return of(this.BUNDLE_SUPER_APP);
  }
}
